import { connect } from 'react-redux'
import { InfosComponent } from './InfosComponent'
import type { RestaurantSubscribeForm } from 'shared/store/restaurant'
import { sendMail } from 'shared/store/restaurant'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => {
    const { kingdomProfilePageState, restaurantPageState } = state
    const {
        coupons,
        couponsError,
        couponsLoaded,
        sendMailSuccess,
        sendMailError
    } = restaurantPageState

    return {
        coupons,
        couponsError,
        sendMailSuccess,
        sendMailError,
        couponsLoaded,
        email: kingdomProfilePageState.email
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    sendMail: (form: RestaurantSubscribeForm) => d(sendMail(form))
})

const Infos = connect(mapStateToProps, mapDispatchToProps)(InfosComponent)

export { Infos }
